import { CoreModel } from '../core/core.model';
import { ButtonModel } from '../button/button.model';
/**
 * MenuItem Class provide each single menu item for md-menu.
 * It is expanding CfCoreComponent. For now it can be used in GC Mneu and GC Button.
 * <h4>Example of MenuItemModel:</h4>
 * <pre>{{'{'}}
 * 	buttonProperty: cfButton,
 * 	divider: true/false,
 * 	notification: ''
 * {{'}'}}</pre>
 */
export class MenuItemModel extends CoreModel {
/**
 * The configuration model for the button.
 */
buttonProperty?: ButtonModel;
/**
 * Show or hide divider. Default: false.
 */
divider?: boolean;
/**
 * Menu item notification.
 */
notification?: string;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function MenuItemModel_tsickle_Closure_declarations() {
/**
 * The configuration model for the button.
 * @type {?}
 */
MenuItemModel.prototype.buttonProperty;
/**
 * Show or hide divider. Default: false.
 * @type {?}
 */
MenuItemModel.prototype.divider;
/**
 * Menu item notification.
 * @type {?}
 */
MenuItemModel.prototype.notification;
}

